<template>
  <div class="exam-root-1">
    <div class="exam-top">
      <img
        src="../../assets/arrow_circle_back.png"
        style="cursor: pointer; width: 36px; height: auto"
        @click="goBack"
      />
      <img
        src="../../assets/loginLogo.png"
        style="height: 30px; margin-left: 30px"
      />
    </div>
    <div class="exam-content">
      <div v-if="!isQuarterThree(item) && project_code != '23-24FELC_Final'" class="certContainer">
        <img
          src="../../assets/felc_cer.jpg"
          class="model"
        />
        <!-- <img
          v-if="item.real_rank <= 30 && item.real_rank > 20"
          src="../../assets/cert_30.jpg"
          class="model"
        />
        <img
          v-if="item.real_rank <= 20 && item.real_rank > 10"
          src="../../assets/cert_20.jpg"
          class="model"
        />
        <img
          v-if="item.real_rank <= 10"
          src="../../assets/cert_10.jpg"
          class="model"
        /> -->
        <div class="ziZm">兹证明</div>

        <div class="event">{{ item.project_name  }}</div>

        <div class="projectName">{{ item.application_event }}</div>

        <div class="award">{{ item.award_show_lable }}</div>

        <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div>

        <div class="student">
        <span class="name">{{ student.student_lastName + student.student_givenName }}</span>
        </div>
        <div class="school">{{ account.account_name }}</div>

        <div class="email">{{ student.student_email }}</div>

        <div class="rhZm">荣获</div>

        <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
        <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
        <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
        <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
        <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
        <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">


        <div class="tefaLab">特发此证，以资鼓励。</div>

        <div class="timeLab">颁发日期：2026年5月5日</div>
        <!-- <div class="timeLab">颁发日期：</div> -->


      </div>

      <div v-if="isQuarterThree(item) && project_code != '23-24FELC_Final'"  class="certContainerFelc">

          <img
              src="../../assets/felc_cer_new.jpg"
              class="model"
              />

            <div class="school">{{ account.account_name }}</div>
            <div class="student">
            <span class="name">{{ student.student_lastName + student.student_givenName }}</span>
            </div>
            <div class="email">{{ student.student_email }}</div>


            <div class="tefaLab">FELC未来企业菁英</div>

            <div class="projectName">{{ getCompetitionName(item) }}</div>

            <div class="event">{{ item.application_event }}</div>

            

            <div class="award">{{ item.award_show_lable }}</div>

            <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div>

            <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
            <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
            <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
            <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
            <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
            <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">


            <div class="timeLab">{{ item.show_time || defaultIssueDateZh(item.quarter) }}</div>
      </div>

      <div v-if="project_code =='23-24FELC_Final'" class="certContainerFelc">

        <img
            src="../../assets/felc_cer_new.jpg"
            class="model"
            />

        <div class="school">{{ account.account_name }}</div>
        <div class="student">
        <span class="name">{{ student.student_lastName + student.student_givenName }}</span>
        </div>
        <div class="email">{{ student.student_email }}</div>


        <div class="tefaLab">23-24学年FELC未来企业菁英</div>

        <div class="projectName">全国高校商科学术竞赛  全国高校企业技能竞赛</div>

        <div class="event">{{ item.application_event }}</div>



        <div class="award">{{ item.award_show_lable }}</div>

        <!-- <div class="awardPh">{{'('+ item.percent_lable + ')'}}</div> -->





        <img class="saiquImg" v-if="item.group_name == '92赛区'" src="../../assets/felc-92赛区.png">
        <img class="saiquImg" v-if="item.group_name == 'FE赛区'" src="../../assets/felc-FE赛区.png">
        <img class="saiquImg" v-if="item.group_name == '标准赛区'" src="../../assets/felc-标准赛区.png">
        <img class="saiquImg" v-if="item.group_name == 'BFA赛区'" src="../../assets/felc-BFA赛区.png">
        <img class="saiquImg" v-if="item.group_name == '国际赛区'" src="../../assets/felc-国际赛区.png">
        <img class="saiquImg" v-if="item.group_name == '职教赛区'" src="../../assets/felc-职教赛区.png">


        <div class="timeLab">2024年8月9日</div>


      </div>
    </div>
  </div>
</template>

<script>
import { findMyTranscript } from "../../api/index";
import {formatDate} from '../../utils/date'
import { getUserId, getProjectCode } from "../../utils/store";
import "../../assets/common/font.css";

export default {
  data() {
    return {
      item: {},
      student: {},
      account: {},
      award_create_time:'2022年12月10日',
      score_id: this.$route.query.score_id,
      project_code:getProjectCode(),
      student_id: this.$route.query.student_id || getUserId()
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    isQuarterThree(item) {
      return item && (item.award_saiji_num === 'Q3' || item.quarter === 'three')
    },
    defaultIssueDateZh(quarter) {
      const match = (this.project_code || '').match(/^(\d{2})-(\d{2})/)
      if (!match) return ''
      const yearEnd = `20${match[2]}`
      if (quarter === 'three') return `${yearEnd}年5月29日`
      if (quarter === 'two') return `${yearEnd}年5月5日`
      return `${yearEnd}年4月3日`
    },
    getCompetitionName(item) {
      if (!item) return ''
      return item.competition_name ||
        item.contest_name ||
        item.award_competition_name ||
        item.project_name ||
        item.award_show_project_name ||
        ''
    },
    fetchData() {
      findMyTranscript(this.student_id, getProjectCode()).then((res) => {
        let score = res.data.data.score_info.find(
          (x) => x._id.$id === this.score_id
        );
       
        var time = JSON.parse(score.create_time) * 1000
        var temp_date = new Date(time)
        // this.award_create_time = formatDate(temp_date, 'yyyy年MM月dd日');
        this.item = score.award_info.award;
        this.student = res.data.data.student_info;
        this.account = res.data.data.account_info;
      });
    },
    handleEventName(event) {
      if (event == undefined) {
        return "";
      }
      let event_array = event.split(" ");
      console.log(111, event, event_array);
      return event_array[0];
    },

    goBack() {
      this.$router.go(-1);
    },
    upfirstName(name) {
      let transferName = name.toLowerCase();
      return transferName.charAt(0).toUpperCase() + transferName.slice(1);
    },
    rank(number) {
      if (number === 1) {
        return "st";
      } else if (number === 2) {
        return "nd";
      } else if (number === 3) {
        return "rd";
      } else {
        return "th";
      }
    },
    printPersonal() {
      let url = this.$router.resolve({
        path: "/blank",
      });
      let newWindow = window.open(url.href, "_blank"); //打印窗口要换成页面的url
      let obj = document.getElementById("cerP");

      let docStr = obj.innerHTML;

      newWindow.document.write(docStr);

      newWindow.document.close();

      newWindow.print();

      newWindow.close();
    },
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "aleo-bold";
  src: url("../../assets/fonts/aleo-bold.ttf");
}
@font-face {
  font-family: "Aleo-Bold-2";
  src: url("../../assets/fonts/Aleo-Bold-2.otf");
}
@font-face {
  font-family: "Aleo-Italic-4";
  src: url("../../assets/fonts/Aleo-Italic-4.otf");
}
@font-face {
  font-family: "Aleo-Light-5";
  src: url("../../assets/fonts/Aleo-Light-5.otf");
}
@font-face {
  font-family: "Aleo-Regular-7";
  src: url("../../assets/fonts/Aleo-Regular-7.otf");
}
.el-dialog {
  width: 320mm;
}
.exam-content {
  width: 100%;
  flex: 1;
  background-image: url("../../assets/exam-content-bg.png");
  background-repeat: no-repeat;
  background-color: transparent;
  background-size: cover;
  box-sizing: border-box;
  position: relative;
  padding: 30px 9vw;
  overflow-x: hidden;
  display: flex;
  justify-content: center;
}

.awardTitle {
  font-weight: bold;
  text-align: center;
  color: #0f429e;
  font-size: 60px;
  margin-top: 30px;
  font-family: Montserrat-SemiBold;
}
.awardTitle1 {
  font-weight: bold;
  text-align: left;
  color: #0036a0;
  font-size: 30px;
  margin-top: 60px;
  margin-left: 80px;
  font-family: Montserrat-SemiBold;
}
.awardLine {
  background-color: #00359f;
  margin-left: 80px;
  margin-right: 80px;
  height: 1px;
  margin-top: 10px;
  font-family: Montserrat-SemiBold;
}
.scoreLab1 {
  margin-top: 60px;
  margin-right: 10px;
  height: 40px;
  //   background-color: rebeccapurple;
  text-align: right;
  font-size: 30px;
  color: #fd5900;
  float: right;
  font-family: Montserrat-SemiBold;
}

.scoreLab2 {
  margin-top: 65px;
  margin-right: 80px;
  height: 40px;
  //   background-color: rebeccapurple;
  text-align: right;
  color: #0f429e;
  font-size: 25px;
  float: right;
  font-family: Montserrat-SemiBold;
}
.awardSubTitle {
  text-align: left;
  color: #2d50b0;
  font-size: 15px;
  margin-top: 20px;
  margin-left: 80px;
  font-family: Montserrat-SemiBold;
}
.returnStyle {
  position: absolute;
  // display: flex;
  // margin-bottom: 10px;
  // align-items: center;
  bottom: 40px;
  margin-left: 45%;
  font-weight: 600;
  width: 140px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  // align-content: center;
  // align-items: center;
  border-radius: 15px;
  background-color: #2d50b0;
  color: white;
  font-family: Montserrat-SemiBold;
}
.box {
  display: flex;
  justify-content: left;
  margin-left: 80px;
  margin-right: 80px;
  margin-top: 20px;
  // height: 250px;
  // background-color: #FD5900;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: left;
  align-content: left;
  text-align: left;
  float: left;
}
.child {
  // width: 50px;
  // background-color: aqua;
  height: 30px;
  padding-left: 10px;
}
.infoStyle {
  display: flex;
  border: 1px solid #2d50b0;
  border-radius: 16px;
  color: #2d50b0;
  margin-left: 20px;
  margin-top: -25px;
  font-family: Montserrat-SemiBold;
}
.infoImg {
  width: 14px;
  height: 14px;
}
.exam-top {
  height: 60px;
  background: #00348b;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 9vw;
}

.exam-root-1 {
  width: 100%;
  height: 100vh;
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.certContainer {
  position: relative;
  color: rgb(42, 70, 154);
  .model {
    width: 297mm;
    height: 208.7mm;
  }
  .event {
    position: absolute;
    font-size: 28px;
    top: 430px;
    left: 116px;
    font-weight: 500;
  }
  .ziZm{
    position: absolute;
    font-size: 18px;
    top: 220px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .rhZm{
    position: absolute;
    font-size: 18px;
    top: 390px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .award {
    position: absolute;
    font-size: 28px;
    top: 525px;
    left: 250px;
    font-weight: 500;
  }
  .projectName{
    position: absolute;
    font-size: 28px;
    top: 480px;
    left: 250px;
    font-weight: 500;
  }
  .awardPh{
    position: absolute;
    font-size: 18px;
    top: 565px;
    left: 250px;
    font-weight: 400;
  }
   
  .tefaLab{
    position: absolute;
    font-size: 18px;
    top: 615px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .timeLab{
    position: absolute;
    font-size: 18px;
    top: 655px;
    left: 116px;
    font-weight: 350;
    color: black;
  }
  .student {
    position: absolute;
    top: 300px;
    left: 116px;
    font-size: 35px;
    // font-style: italic;
    font-weight: 600;
    .name {
      margin-right: 40px;
    }
  }
  .email{
    position: absolute;
    top: 350px;
    left: 116px;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    top: 260px;
    left: 116px;
    font-size: 23px;
    font-weight: 350;
  }
  .saiquImg{
    position: absolute;
    top: 480px;
    left: 116px;
    width: 120px;
    height: 110px;
    // background-color:  white;
  }
}
.certContainerFelc{
  position: relative;
  color: #333;
  font-family: 'SourceHanSansCN-Bold';

  .model {
    width: 210mm;
    height: 295mm;
    z-index: 0;
  }
  .event {
    position: absolute;
    font-size: 25px;
    top: 550px;
    // left: 116px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
  }
 
  .award {
    position: absolute;
    font-size: 38px;
    top: 645px;
    left: 105mm;
    font-weight: 500;
    color: #233C85;
  }
  .projectName{
    position: absolute;
    font-size: 20px;
    top: 505px;
    // left: 250px;
    text-align: center;
    width: 210mm;
    font-weight: 600;
  }
  .awardPh{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 700px;
    left: 105mm;
    color: gray;
    font-weight: 400;
  }

  .tefaLab{
    position: absolute;
    font-size: 20px;
    top: 460px;
    font-weight: 600;
    text-align: center;
    width: 210mm;
    color: black;
  }
  .timeLab{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    font-size: 18px;
    top: 812px;
    left: 105mm;
    font-weight: 350;
    color: black;
  }
  .student {
    position: absolute;
    top: 330px;
    // left: 116px;
    text-align: center;
    font-size: 35px;
    width: 210mm;
    // background-color: #003262;
    // font-style: italic;
    font-weight: 600;
    .name {
      // margin-right: 40px;
    }
  }
  .email{
    font-family: 'SourceHanSansCN-Normal';
    position: absolute;
    top: 388px;
    // left: 116px;
    width: 210mm;
    text-align: center;
    font-size: 20px;
    // font-style: italic;
    font-weight: 350;
  }
  .school {
    position: absolute;
    font-weight: 600;
    width: 210mm;
    text-align: center;
    top: 295px;
    // left: 116px;
    font-size: 23px;
    font-weight: 450;
  }
  .saiquImg{
    position: absolute;
    top: 620px;
    left: 250px;
    width: 140px;
    height: 130px;
    // background-color:  white;
  }
}
</style>
